export default {
  login:[{
    authenticated: false
  }],
  user: [],
  userCreated: [],
  establishments: [],
  establishmentUsers: [],
  caseDatas:[],
  frontPageFilter: [],
  submissions: [],
  forms:[],
  errors:[],
  injurySummaries: [],
  ajaxCallsInProgress: 0,
  fileSubmission: [],
  statePlanStates: null,
  helpDeskEmail:[],
  naicsCodes:[]
};



/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/